export default __webpack_public_path__ + "static/media/quakingAspen.51388f14.jpg";